import { useEffect, useState } from 'react';
import {
  clearAccountActionResult,
  peekAccountActionResult,
  UPDATE_PASSWORD_ACTION,
  type AccountActionStatus,
} from '@/core/auth';
import { cn } from '@/core/ui';
import { CheckCircle, WarningCircle, X } from '@/core/ui/icons';

const MESSAGES: Record<AccountActionStatus, string> = {
  success: 'Senha alterada. Use a nova senha no próximo login.',
  cancelled: 'Troca de senha cancelada. Sua senha continua a mesma.',
  error: 'Não foi possível alterar a senha. Tente novamente.',
};

/**
 * Aviso na volta do "Alterar senha": o Keycloak devolve a pessoa logada
 * nos dois casos (alterou ou cancelou), então a única diferença visível é
 * esta mensagem. Some sozinho depois de alguns segundos.
 */
export function AccountActionNotice() {
  const [result, setResult] = useState(peekAccountActionResult);

  useEffect(() => {
    if (!result) return;
    clearAccountActionResult();
    const timer = window.setTimeout(() => setResult(null), 8000);
    return () => window.clearTimeout(timer);
  }, [result]);

  if (!result || result.action !== UPDATE_PASSWORD_ACTION) return null;
  const ok = result.status === 'success';

  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md items-start gap-3 rounded-2xl glass-strong p-4 text-sm shadow-float sm:right-6 sm:left-auto sm:mx-0"
    >
      {ok ? (
        <CheckCircle aria-hidden weight="fill" className="mt-0.5 size-5 shrink-0 text-brand-300" />
      ) : (
        <WarningCircle
          aria-hidden
          weight="fill"
          className={cn(
            'mt-0.5 size-5 shrink-0',
            result.status === 'error' ? 'text-red-400 light:text-red-600' : 'text-fg-subtle',
          )}
        />
      )}
      <p className="flex-1 text-fg">{MESSAGES[result.status]}</p>
      <button
        type="button"
        onClick={() => setResult(null)}
        aria-label="Fechar aviso"
        className="-m-1 rounded-lg p-1 text-fg-subtle hover:bg-surface-3 hover:text-fg"
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
